import { useState, type ReactNode } from "react";

/** Collapsible section with a live count — collapsed by default, scrollable body.
 *  (Prototype rule: history is one click away, never scrolling past you.) */
export function CollapsibleSection({
  title,
  count,
  children,
  maxHeight = 460,
  defaultOpen = false,
}: {
  title: string;
  count?: number;
  children: ReactNode;
  maxHeight?: number;
  defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <>
      <button className="secbtn" onClick={() => setOpen((o) => !o)}>
        <span className="chev">{open ? "▾" : "▸"}</span> {title}
        {count !== undefined && <span className="seccnt">({count})</span>}
      </button>
      {open && (
        <div className="secbody" style={{ maxHeight, overflowY: "auto", paddingRight: 6 }}>
          {children}
        </div>
      )}
    </>
  );
}
